import { z } from 'zod';

const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'expected YYYY-MM-DD');
const fiscalYear = z.number().int().min(2000).max(2100);

export const yearEndPreviewQuerySchema = z.object({
  fiscalYear: z.coerce.number().int().min(2000).max(2100),
  asOfDate: isoDate,
});
export type YearEndPreviewQuery = z.infer<typeof yearEndPreviewQuerySchema>;

export const runYearEndCloseInputSchema = z.object({
  fiscalYear,
  asOfDate: isoDate,
});
export type RunYearEndCloseInput = z.infer<typeof runYearEndCloseInputSchema>;

export const reverseYearEndCloseInputSchema = z.object({
  reason: z.string().trim().min(1).max(500),
});
export type ReverseYearEndCloseInput = z.infer<typeof reverseYearEndCloseInputSchema>;

export interface YearEndCloseAccountLine {
  accountId: string;
  code: string;
  name: string;
  accountType: string;
  /** The amount posted to zero the account in the closing entry. */
  amount: string;
  /** The side used to close it (opposite of the account's running balance). */
  side: 'debit' | 'credit';
}

export interface YearEndClosePreview {
  fiscalYear: number;
  asOfDate: string;
  netIncome: string; // revenue − expense for the period being closed
  retainedEarningsCode: string;
  lines: YearEndCloseAccountLine[];
  canClose: boolean;
  blockers: string[]; // hard — prevent the close
  warnings: string[]; // soft — shown but allowed
}

export interface YearEndClosing {
  id: string;
  companyId: string;
  fiscalYear: number;
  asOfDate: string;
  journalEntryId: string;
  netIncome: string;
  status: 'closed' | 'reversed';
  reverseReason: string | null;
  reversedAt: string | null;
  createdAt: string;
}

export interface RunYearEndCloseResult {
  closing: YearEndClosing;
  journalEntryId: string;
  netIncome: string;
}
